import React, {useEffect, useState} from "react";
import Dialog from "../../../components/Dialog/Dialog";
import {withStyles} from "@material-ui/core";
import CloseIcon from "../../../components/Icon/Close";
import {Button} from "../../../components/ui/Buttons";
import InputForm from "../../../components/Input/InputForm";
import InputDateForm from "../../../components/Input/InputDateForm";
import InputTimeForm from "../../../components/Input/InputTimeForm";
import {TextFieldSearch} from "../../../components/TextField";
import {getProfissionalSaudeLogado} from "../../../services/UsuarioService";
import {findAllProfissionalSaude} from "../../../services/ProfissionalSaudeService";
import {createExameWorkList} from "../../../services/ExamePacswebService";
import {inject} from "mobx-react";
import {observer} from "mobx-react-lite";
import {
  findAllProcedimentosPacsweByAgendamentoId,
  findProcedimentosWithModalidade
} from "../../../services/ProcedimentoService";

const formDataDefault = {
  exames: [],
    atendimentoData: new Date(),
    atendimentoHora: new Date(),
    profissional: null,
    status: "I",
    aet: "*",
}

const ModalIncluirExamePacsweb = observer(({ classes, open, onClose, onSave, sujeitoAtencao, showAlertMessage, exameStore, history }) => {

  const [formData, setFormData] = useState({
    ...formDataDefault
  });
  const [selectValue, setSelectValue] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect( () => {
    findProfissionalSaude() 
  }, []);
 
  useEffect(() => {
    if (history?.location?.agendamento) {
      const { agendamento } = history?.location

      findExamesPacswebByAgendamentoId(agendamento?.id)
    }
  }, [history?.location?.agendamento?.id]);

  const findExamesPacswebByAgendamentoId = async (agendamentoId) => {
    try {

      const procedimentos = await findAllProcedimentosPacsweByAgendamentoId({ agendamentoId })
      setFormData(prev => ({
        ...prev,
        exames: procedimentos.map(exame => ({
          ...exame,
          agendamento: {
            id: agendamentoId
          }
        }))
      }))

    } catch (e) {
      console.error(e)

    }
  }

  const findProfissionalSaude = async ()=>{
    const profissionalLogado = await getProfissionalSaudeLogado()

    if (profissionalLogado?.tipo === 1) {
      setFormData((prev) => ({       
        ...prev,
        profissional: {
          id: profissionalLogado.id,
          nome: profissionalLogado.nome,
        },
      }));
    }
  }

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleExameChange = (exame) => {
    if (!exame) return;
    if (formData.exames.some((item) => item?.id === exame?.id)) return;
    setFormData((prev) => ({
      ...prev,
      exames: [...prev.exames, exame],
    }));
    setSelectValue(null);
  };

  const handleRemoveExame = (exameId) => {
    setFormData((prev) => ({
      ...prev,
      exames: prev.exames.filter((e) => e.id !== exameId),
    }));
  };

  const handleProfissionalChange = (profissional) => {
    setFormData((prev) => ({ ...prev, profissional }));
  };

  const loadExames = async (search, loadedOptions, { page }) => {
    try {
      const { content, last } = (
        await findProcedimentosWithModalidade({
          nome: search,
          ativo: true,
          possuiModalidade:true,
          possuiTussVinculado: true,
          pageableDto: { pageNumber: page, pageSize: 30 },
        })
      ).data.data.findAllProcedimentos;
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error(error);
    }
  };

  const loadProfissionais = async (search, loadedOptions, { page }) => {
    try {
         const { content, last } = (
           await findAllProfissionalSaude({
             pageNumber: page,
             search,
           })
         ).data.data.findAllProfissionalSaude
         return {
           options: content,
           hasMore: !last,
           additional: {
             page: page + 1,
           },
         }
       } catch (error) {
         console.error(error)
       }
  };

  const clearFormData=()=>{
    setFormData({
      ...formDataDefault
    })
  }

  const handleSave = async () => {

    try {
      const payload = {
        sujeitoAtencaoId: sujeitoAtencao?.id,
        profissinalId: formData?.profissional?.id,
        exames: formData?.exames?.map(exame => ({
          exameNome: exame?.nome,
          modalidade: exame?.modalidadeExames?.[0]?.codigo,
          status: "INSERT",
          exameCodigo: exame?.tuss22ProcedimentoEventoSaude?.codigoTermo,
          ...(exame?.agendamento?.id && {
            agendamento: {
              id: exame?.agendamento?.id
            }
          })
        })),
      }

      await createExameWorkList(payload)
      showAlertMessage({
        isOpen: true,
        message: "Exames solicitados com sucesso!",
        variant: "success",
      })
      onSave();
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        message: "Erro ao solicitar exames!",
        variant: "error",
      })
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const closeModal =()=>{
    clearFormData();
    history.location.agendamento = null
    onClose();
  }

  return (
    <Dialog open={open} onClose={closeModal} classes={{ paper: classes.paper }}>
      <div className={classes.root}>
        <div className={classes.header}>
          <div className={classes.title}>Incluir Exame Pacsweb</div>
          <div onClick={closeModal} className={classes.close}>
            <CloseIcon />
          </div>
        </div>

        <div className={classes.content}>
          <div className={classes.rowPaciente}>
            <div className={classes.field}>
              <label className={classes.label}>Nome do Paciente *</label>
              <InputForm
                value={sujeitoAtencao?.nome || ""}
                classes={{ input: classes.input }}
                disabled
              />
            </div>
            <div className={classes.field}>
              <label className={classes.label}>CPF *</label>
              <InputForm
                value={sujeitoAtencao?.documento || ""}
                classes={{ input: !sujeitoAtencao?.documento ? classes.inputError : classes.input }}
                disabled
              />
            </div>
            <div className={classes.field}>
              <label className={classes.label}>Data Nascimento *</label>
              <InputDateForm
                value={sujeitoAtencao?.dataNascimento || null}
                classes={{ input: !sujeitoAtencao?.dataNascimento ? classes.inputError : classes.input }}
                disabled
              />
            </div>
          </div>

          <div className={classes.row}>
            <div className={classes.field}>
              <label className={classes.label}>Data Atendimento *</label>
              <InputDateForm
                value={formData.atendimentoData}
                onChange={(date) => handleChange("atendimentoData", date)}
                classes={{ input: classes.input }}
                disabled
              />
            </div>
            <div className={classes.field}>
              <label className={classes.label}>Hora Atendimento *</label>
              <InputTimeForm
                value={formData.atendimentoHora}
                onChange={(time) => handleChange("atendimentoHora", time)}
                InputProps={{
                  classes: {
                    root: classes.timeInput,
                    input: classes.timeInputField,
                  },
                  disableUnderline: true,
                }}
                helperText=""
                disabled
              />
            </div>
          </div>

          <div className={classes.rowFull}>
            <div className={classes.field}>
              <label className={classes.label}>Profissional *</label>
              <TextFieldSearch
                onChange={handleProfissionalChange}
                loadOptions={loadProfissionais}
                placeholder="Selecione"
                classIcons={classes.classIcons}
                classInput={classes.reactSelect}
                classNotched={classes.notchedOutline}
                getOptionLabel={(option) => option?.nome}
                getOptionValue={(option) => option?.id}
                value={formData?.profissional}
                classes={{ paper: classes.menuHeight }}
                withPaginate
                debounceTimeout={300}
                additional={{
                  page: 0,
                }}
                menuPosition="fixed"
              />
            </div>
          </div>

          <div className={classes.rowFull}>
            <div className={classes.field}>
              <label className={classes.label}>Nome do Exame *</label>
              <TextFieldSearch
                value={selectValue}
                onChange={handleExameChange}
                loadOptions={loadExames}
                menuPosition="fixed"
                menuPortalTarget={document.body}
                getOptionLabel={(option) => option?.nome}
                getOptionValue={(option) => option?.id}
                withPaginate
                debounceTimeout={300}
                additional={{
                  page: 0,
                }}
                isClearable
                isDisabled={!sujeitoAtencao?.documento || !sujeitoAtencao?.dataNascimento}
              />
            </div>
          </div>

          <div className={classes.examesList}>
            <label className={classes.label}>Exames Selecionados:</label>
            <div className={classes.examesItems}>
              {formData?.exames?.length === 0 ? (
                <div className={classes.emptyMessage}>
                  Nenhum exame selecionado
                </div>
              ) : (
                formData?.exames?.map((exame) => (
                  <div key={exame.id} className={classes.exameItem}>
                    <div className={classes.exameInfo}>
                      <span>{exame.nome}</span>
                      {exame.modalidadeExames &&
                        exame.modalidadeExames.length > 0 && (
                          <span className={classes.modalidadeLabel}>
                            {exame.modalidadeExames[0].descricao}
                          </span>
                        )}
                    </div>
                    <div
                      className={classes.removeIcon}
                      onClick={() => handleRemoveExame(exame.id)}
                    >
                      <CloseIcon />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        <div className={classes.footer}>
          <Button kind="transparent" onClick={closeModal}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleSave();
              setLoading(true)
            }}
            disabled={loading || !formData?.exames?.length || !formData?.profissional}
          >
            {loading ? 'Salvando...' : 'Salvar'}
          </Button>
        </div>
      </div>
    </Dialog>
  );
});

const styles = {
  paper: {
    width: "100%",
    maxWidth: "700px",
    maxHeight: "85vh",
    borderRadius: "12px",
    overflow: "visible",
  },
  root: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "visible",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
  },
  close: {
    cursor: "pointer",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    overflowY: "auto",
    maxHeight: "calc(85vh - 200px)",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  rowPaciente: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr",
    gap: "16px",
  },
  rowFull: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minWidth: 0,
  },
  label: {
    fontSize: "12px",
    color: "#868686",
    fontWeight: 500,
  },
  input: {
    background: "#f2f2f2",
    border: "none",
    color: "#505050",
  },
  inputError: {
    background: "#f2f2f2",
    border: "1px solid #f44336",
    color: "#505050",
    borderRadius: "5px",
  },
  errorMessage: {
    fontSize: "11px",
    color: "#f44336",
    marginTop: "-4px",
  },
  timeInput: {
    background: "#f2f2f2",
    border: "none",
    borderRadius: "5px",
    height: "40px",
    marginTop: "0 !important",
  },
  timeInputField: {
    background: "#f2f2f2",
    border: "none",
    color: "#505050",
    paddingTop: "11px",
    paddingLeft: "10px",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "24px",
  },
  examesList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minHeight: "170px",
  },
  examesItems: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "150px",
    overflowY: "auto",
    padding: "8px",
    background: "#fafafa",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  emptyMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: "#868686",
    fontSize: "14px",
    fontStyle: "italic",
  },
  exameItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    background: "#fff",
    borderRadius: "6px",
    fontSize: "14px",
    border: "1px solid #e0e0e0",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
      borderColor: "#d0d0d0",
    },
    "& span": {
      color: "#505050",
      fontWeight: 500,
    },
  },
  exameInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: 1,
  },
  modalidadeLabel: {
    fontSize: "12px",
    color: "#868686",
    fontWeight: "normal",
  },
  removeIcon: {
    cursor: "pointer",
    fontSize: "22px",
    fontWeight: "bold",
    color: "#868686",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#fff",
      background: "#726e6e",
    },
  },
};

const stores = ["exameStore"];
const ModalIncluirExamePacwebWithStyles = withStyles(styles)(
  ModalIncluirExamePacsweb
);
export default inject(stores)(ModalIncluirExamePacwebWithStyles);
